import React from 'react'
import logo from '../assets/LexiTrove Logo.svg'

function navbar() {
  return (
    <div className='navbar'>
        <div className='logo'>
            
            <img src={logo}></img>
            <a href='/'><span>LexiTrove</span></a>
        </div>
        <div className='menu'>
            <ul>
            <li><a href='/blog'>Blogs</a></li>
            </ul>
        </div>
    </div>
  )
}

export default navbar